'use client';

import clsx from 'classnames';
import { useRef } from 'react';

import { useTranslation } from '@/i18n/client';
import { Image } from '@/shared/components/image';

import styles from './DeliveryTable.module.scss';
import { DeliveryTableProps } from './types';
import { imageBreakpoints } from './utils';

export const DeliveryTable = ({ rows }: DeliveryTableProps) => {
  const { t } = useTranslation(['delivery', 'common']);
  const upperScrollRef = useRef<HTMLDivElement>(null);
  const bottomScrollRef = useRef<HTMLDivElement>(null);

  const horizontalScrollSync = (
    event: React.UIEvent<HTMLDivElement>,
    oppositeRef: React.RefObject<HTMLDivElement>
  ) => {
    if (!oppositeRef.current) {
      return;
    }
    oppositeRef.current.scrollLeft = event.currentTarget.scrollLeft;
  };

  const isDescriptionShow = rows.some((item) => item.details !== '-');

  return (
    <div className={styles['SimpleTable']}>
      <div
        className={styles['SimpleTable__table-fake-wrapper']}
        onScroll={(event) => horizontalScrollSync(event, bottomScrollRef)}
        ref={upperScrollRef}
      >
        <div className={styles['SimpleTable__table-scroll-top']} />
      </div>
      <div
        className={styles['SimpleTable__table-wrapper']}
        onScroll={(event) => horizontalScrollSync(event, upperScrollRef)}
        ref={bottomScrollRef}
      >
        <table className={styles['SimpleTable__table']}>
          <tbody>
            <tr>
              <th>{t('breadcrumbs.delivery')}</th>
              <th
                className={clsx(
                  styles['SimpleTable__table--center-align'],
                  styles['SimpleTable__table--thin-cell']
                )}
              >
                {t('deliveryOptions.shipmentCost')}*
              </th>
              <th
                className={clsx(
                  styles['SimpleTable__table--center-align'],
                  styles['SimpleTable__table--thin-cell']
                )}
              >
                {t('deliveryOptions.transportTime')}
              </th>
              {isDescriptionShow ? (
                <th
                  className={clsx(
                    styles['SimpleTable__table--center-align'],
                    styles['SimpleTable__table--thin-cell']
                  )}
                >
                  {t('common.serviceDescription')}
                </th>
              ) : null}
            </tr>
            {rows.map((item, index) => (
              <tr key={index}>
                <td className={styles['SimpleTable__table--title']}>
                  <div className={styles['SimpleTable__table--title-cell']}>
                    <Image
                      alt={item.title}
                      title={item.title}
                      src={item.imageUrl}
                      breakpoints={imageBreakpoints}
                      loader={false}
                    />
                    {item.title}
                  </div>
                </td>
                <td
                  className={clsx(
                    styles['SimpleTable__table--center-align'],
                    styles['SimpleTable__table--thin-cell']
                  )}
                >
                  {item.cost}
                </td>
                <td
                  className={clsx(
                    styles['SimpleTable__table--center-align'],
                    styles['SimpleTable__table--thin-cell']
                  )}
                >
                  {item.time}
                </td>
                {isDescriptionShow ? (
                  <td className={clsx(styles['SimpleTable__table--thin-cell'])}>
                    {item.details}
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
